import { render, staticRenderFns } from "./column-param-item.vue?vue&type=template&id=6b37b818&scoped=true"
import script from "./column-param-item.vue?vue&type=script&lang=js"
export * from "./column-param-item.vue?vue&type=script&lang=js"
import style0 from "./column-param-item.vue?vue&type=style&index=0&id=6b37b818&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b37b818",
  null
  
)

export default component.exports